import { QuestionCircleOutlined } from '@ant-design/icons'
import { corpImage } from '@components/Hotel/util'
import { isWeddingDressPhotoProperty } from '@merchant-backend/util'
import { isStoreAccount } from '@util'
import { Modal } from 'hljd'
import React from 'react'
import { Link } from 'react-router'
import style from './index.module.less'

export default store => {
  const delDraft = id => {
    Modal.confirm({
      title: '确定删除该案例吗？',
      onOk() {
        store.delDraft(id)
      }
    })
  }
  return [
    {
      title: '案例名称',
      dataIndex: 'name',
      key: 'name',
      width: 400,
      render: (text, record) => {
        const src =
          record.verticalImage ||
          'https://qnm.hunliji.com/Fkgr3Q93xWK3MLJrSS24vgA3Cjpo?imageView2/1/w/288/h/288'
        return (
          <div className={style.nameWrap}>
            <img
              src={corpImage(src, '1:1', 64)}
              style={{
                border: !record.vertical_image ? 'none' : '1px solid #e2e2e2'
              }}
            />
            <div className={style.name}>
              <h5>
                <a>{record.title}</a>
              </h5>
            </div>
          </div>
        )
      }
    },
    {
      title: '类型',
      dataIndex: 'mealType',
      render: mealType => {
        if (mealType == undefined) {
          return '-'
        }
        return mealType == 1 ? '样片' : '客照'
      },
      hidden: () => {
        if (isStoreAccount()) {
          return +store.currentProperty !== 6
        } else {
          return !isWeddingDressPhotoProperty()
        }
      }
    },
    {
      title: (
        <span>
          关联客照&nbsp;
          <a href="#/localMerchant/case/introduce" style={{ color: '#ff8c30' }}>
            <QuestionCircleOutlined />
          </a>
        </span>
      ),
      dataIndex: 'sampleRelatedPicCount',
      render: (text, record) => {
        return record.mealType == 1 ? (
          <Link to={'/localMerchant/case/unionPhoto/' + record.id}>
            已关联{text || '0'}张
          </Link>
        ) : (
          <span>-</span>
        )
      },
      hidden: () => {
        if (isStoreAccount()) {
          return +store.currentProperty !== 6
        } else {
          return !isWeddingDressPhotoProperty()
        }
      }
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      render: text => text || '-'
    },
    {
      title: '操作',
      dataIndex: 'edit',
      render: (
        text,
        record //第一个tab和最后一个tab分上架下架，其他根据is_sold_out判断
      ) => {
        return (
          <>
            <p>
              <a style={{ color: '#508cee' }} onClick={store.toEdit(record)}>
                编辑
              </a>
            </p>
            <a style={{ color: '#508cee' }} onClick={() => delDraft(record.id)}>
              删除
            </a>
          </>
        )
      }
    }
  ]
}
